export class ChangerEtape
{
    currentTaskId:String;
    commentaire:String;
    cancelActivityId:String;
    startActivityId:String;
}